module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/FlyerVideo-42347b48fbb4da056594f0ac38a66c06.mp4";